export const QUESTION_TYPE = {
  BOOLEAN: 1,
  TEXT_ONLY: 2,
};

export const QUESTION_DISPLAY_TYPE = {
  TEXTBOX_ON_YES: 'TextboxOnYes',
  CHECK_BOX: 'CheckBox',
};
